import KendoMap from './KendoMap'
import KendoMapMarker from './KendoMapMarker'
import KendoMapLayer from './KendoMapLayer'
import KendoMapInstaller from './kendo-map-installer'

export { KendoMap, KendoMap as Map, KendoMapMarker, KendoMapMarker as MapMarker, KendoMapLayer, KendoMapLayer as MapLayer, KendoMapInstaller, KendoMapInstaller as MapInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/index.js